import "./anchor.css"


function Anchor({divId}) {

    return (
        <div id={divId} className="anchor"></div>
    );
}
export default Anchor